// extracted by mini-css-extract-plugin
export default {"wrapper":"Card_wrapper__Una0p","header":"Card_header__MuJWa","content":"Card_content__1sqdI","footer":"Card_footer__9TBgf"};